import { MemoryStorage, AppStates } from '@Engage.Core';
import { StorageKeyPrefixes } from '../../constants/Constants';
export class StorageService {
    constructor() {
        this.secretKey = 'dfsdfsdfsdf';
    }
    expandKey(key) {
        let appOptions = MemoryStorage.get(AppStates.AppOptions);
        if (!appOptions)
            return '';
        let siteCode = appOptions.get(AppStates.SiteCode);
        let configCode = appOptions.get(AppStates.ConfigCode);
        if (!siteCode || !configCode)
            return '';
        return [key, siteCode.toUpperCase(), configCode.toUpperCase(), appOptions.get(AppStates.Environment).toUpperCase()].join('_');
    }
    getConstantKeys(constantsObject) {
        let constantsKeys = [];
        Object.keys(constantsObject).forEach(objectKey => {
            if (!constantsObject.hasOwnProperty(objectKey))
                return;
            if (typeof constantsObject[objectKey] == 'object') {
                constantsKeys = constantsKeys.concat(this.getConstantKeys(constantsObject[objectKey]));
            }
            else {
                constantsKeys.push(constantsObject[objectKey]);
            }
        });
        return constantsKeys;
    }
    removeExceptionsFromKeys(keys) {
        const exceptions = [StorageKeyPrefixes.Cookie];
        return keys.filter(key => !exceptions.some(exception => key == exception));
    }
    filterConnextExistingStorageKeys(existingKeys, constantKeys) {
        return existingKeys.filter(existingKey => constantKeys.some(constantKey => existingKey.startsWith(constantKey)
            || existingKey.startsWith(StorageKeyPrefixes.Cookie + constantKey)
            || existingKey.startsWith(StorageKeyPrefixes.LSDublicateCookie + constantKey)
            || existingKey.startsWith(StorageKeyPrefixes.LSDublicateCookie + StorageKeyPrefixes.Cookie + constantKey)));
    }
}
